// extracted by mini-css-extract-plugin
module.exports = {"fieldBox":"TextFieldWithFadeContent_fieldBox__3vLKY","fadeBox":"TextFieldWithFadeContent_fadeBox__s7-_8"};